import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "time-from-now" }
const _hoisted_2 = {
  key: 0,
  class: "x-from-now__absolute"
}
const _hoisted_3 = {
  key: 1,
  class: "x-from-now__relative"
}

import { computed, inject, onUnmounted, ref, type PropType } from 'vue';

import { CONSTANTS } from '@exchange/libs/utils/constants/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeFromNow',
  props: {
  date: {
    type: Date as PropType<Date>,
    required: true,
  },
  format: {
    type: String,
  },
  forceAbsoluteTime: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const utcToLocal = inject<(utcDateString: string | Date | number, formatString?: string) => string>('utcToLocal');

const now = ref(Date.now());
const dateFormat = computed(() => props.format || CONSTANTS.DATE_FORMAT);
const noFuture = computed(() => {
  const time = props.date.getTime();

  return time > now.value ? now.value : time;
});
const showAbsoluteTime = computed(() => Date.now() - props.date.getTime() > 1000 * 60 * 60 * 24);

const updateNow = () => {
  now.value = Date.now();
};

const interval = setInterval(() => updateNow(), 1000);

onUnmounted(() => clearInterval(interval));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (__props.forceAbsoluteTime || showAbsoluteTime.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(utcToLocal)(__props.date, dateFormat.value)), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(utcToLocal)(noFuture.value, 'fromNow')), 1))
  ]))
}
}

})